import React from 'react';
import NewsletterSignup from ':src/modules/global/NewsletterSignup';

export default function About() {
  return (
    <>
      <div className="container pt-10">
        <div className="mx-auto max-w-prose">
          <h2 className="h3 mb-4">What’s this site?</h2>
          <p className="mb-8">
            This site is a repository of questions for frontend engineer job
            seekers looking to test themselves prior to going into interviews
            (or if you’re just looking for a challenge to level up your skills).
          </p>

          <h2 className="h3 mb-4">
            What makes this site different from other interview prep resources?
          </h2>
          <p className="mb-4">
            At many companies, algorithmic interview questions have fallen out
            of favor when hiring frontend engineers. The reason is obvious:
            these questions are nearly worthless when it comes to evaluating how
            well a frontend engineer can do their job. Companies have begun
            shifting towards practical questions that test actual frontend
            skills, like implementing UIs, creating interactive features, doing
            so in an accessible and performant way, etc.
          </p>

          <p className="mb-8">
            While the evolution towards more practical evaluation is generally a
            positive trend, it doesn’t help you much when it comes to your
            interview prep. Most interview prep resources are geared towards
            algorithmic interviews. Usually the most you’ll get is that you can
            do the algorithmic interview exercises in JavaScript/TypeScript.
            This site is built to give you practice with more of the practical
            exercises you’ll encounter in modern frontend interviews.
          </p>

          <h2 className="h3 mb-4">Who are you?</h2>
          <p className="mb-12">
            This site was built by three engineers, from the West Coast (Bay
            Area) to the East Coast (NYC). Our team consists of a current-Airbnb
            frontend engineer, ex-Google, ex-Airbnb frontend engineer, and an
            Amazon frontend engineer. We started this project out of our own
            frustration towards the lack of frontend-specific interview
            resources. We’ve done plenty of interviews in our time, securing
            offers in recent years from companies like Lyft, Stripe, Square, and
            Netflix, and are hoping to share some of our interviewing expertise
            with you.
          </p>
        </div>
      </div>
      <NewsletterSignup />
    </>
  );
}
